module.exports = __webpack_public_path__ + "assets/img/warrior-name-6d60f64d.png";